/**
 * 発注の状態の表示 (バッジの色)。文言は shared の PURCHASE_ORDER_STATUS_LABEL。
 * 入荷済 = 紫、検品済 = 緑 (docs/04_design/fulfillment_inspection_mockup)。
 */
import type { PurchaseOrderStatus } from '@goenhub/shared';

export type PoBadgeVariant = 'default' | 'draft' | 'sent' | 'review' | 'approved';

export const PO_STATUS_VARIANT: Record<PurchaseOrderStatus, PoBadgeVariant> = {
  pending: 'draft',
  ordered: 'sent',
  received: 'review',
  inspected: 'approved',
  shipped: 'default',
  cancelled: 'default',
};

/** 今日の日付 (端末の時刻、YYYY-MM-DD)。 */
export function todayYmd(): string {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
}

/** 'YYYY-MM-DD' を「2026/11/04」に。空は '-'。 */
export function fmtYmd(ymd: string | null | undefined): string {
  if (!ymd) return '-';
  return ymd.replace(/-/g, '/');
}
